"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("src/utils/axios"));
class Requests {
    constructor() {
        this.getHotspots = (widgetKey) => __awaiter(this, void 0, void 0, function* () {
            return axios_1.default.get(`/api/v1/widget/hotspots/?widget_key=${widgetKey}`, {
                method: "GET",
            });
        });
        this.getTours = (widgetKey) => __awaiter(this, void 0, void 0, function* () {
            return axios_1.default.get(`/api/v1/widget/tours/?widget_key=${widgetKey}`, {
                method: "GET",
            });
        });
        this.identify = (data, widgetKey, token) => __awaiter(this, void 0, void 0, function* () {
            return axios_1.default.post(`/api/v1/widget/statistic/identify/?widget_key=${widgetKey}`, data, {
                headers: {
                    "X-WIDGET-SESSION": token || "",
                },
            });
        });
        this.track_tour = (tour_id, data, widgetKey, token) => __awaiter(this, void 0, void 0, function* () {
            return axios_1.default.post(`/api/v1/widget/statistic/tour/${tour_id}/track/?widget_key=${widgetKey}`, data, {
                headers: {
                    "X-WIDGET-SESSION": token,
                },
            });
        });
    }
}
exports.default = Requests;
